import React from "react";
import Navbar from "../components/landing/Navbar";
import Hero from "../components/landing/Hero";
import Services from "../components/landing/Services";
import Projects from "../components/landing/Projects";
import Process from "../components/landing/Process";
import About from "../components/landing/About";
import Testimonials from "../components/landing/Testimonials";
import Contact from "../components/landing/Contact";
import Footer from "../components/landing/Footer";
import { ContentProvider } from "../hooks/useContent";

const LandingPage = () => {
  return (
    <ContentProvider>
      <div className="relative">
        <Navbar />
        <Hero />
        <About />
        <Services />
        <Process />
        <Projects />
        <Testimonials />
        <Contact />
        <Footer />
      </div>
    </ContentProvider>
  );
};

export default LandingPage;
